<div *ngIf="relatedLink">
  <div [innerHtml]="relatedLink"></div>
</div>
